<template>
    <div v-if="modelValue" class="modal" @mousedown.self="handleOverlayClick">
        <slot />
    </div>
</template>

<script setup>
import { watch, computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    forceClose: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['update:modelValue', 'close']);

let scrollY = 0;

function disableBodyScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
}

function enableBodyScroll() {
    const savedY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, parseInt(savedY || '0') * -1);
}

watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal) {
            disableBodyScroll();
        } else {
            enableBodyScroll();
        }
    },
);

function handleOverlayClick() {
    if (!props.forceClose) {
        close();
    }
}

const close = () => emit('close');
</script>

<style scoped lang="scss">
@use 'ihunter-pathfinder/styles' as Pathfinder;

.modal {
    position: fixed;
    inset: 0;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    padding: Pathfinder.$space-300;
    background: var(--surface-blur);
}
</style>
